import RestService from './_private/RestService';
import { VideoProviderType } from '@core/models/offer/enums';
import { VideoType } from './enums';

export default class MediaService {
    constructor(private restService = new RestService()) {}

    public async getMatchVideoStream(
        providers: {
            [VideoProviderType.BETRADAR]?: number,
            [VideoProviderType.IMG]?: number,
        }) {
        let matchId;
        let response;

        try {
            if (providers[VideoProviderType.IMG]) {
                matchId = providers[VideoProviderType.IMG];
                response = await this.restService.getMatchVideoStreamData(VideoProviderType.IMG, matchId);
                try {
                    response = await this.restService.getImgStream(matchId!, response);
                    response = {
                        streamUrl: response.hlsUrl,
                        videoType: VideoType.hls,
                    };
                } catch (e) {
                    throw e;
                }
            } else {
                matchId = providers[VideoProviderType.BETRADAR];
                response = await this.restService.getMatchVideoStreamData(VideoProviderType.BETRADAR, matchId);
                const streamData = response.data && response.data.stream;

                if (!streamData) {
                    throw response;
                }
                response = {
                    streamUrl: streamData.m3u8Uri,
                    videoType: VideoType.m3u8,
                };
            }
        } catch (e) {
            throw e;
        }

        return response as {
            streamUrl: string,
            videoType: VideoType,
        };
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/core/services/media/MediaServiceAPI.ts